import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CrudItemComponent, NavItem } from '@hutsix/ngxh6';
import { JobCardInterface } from '../../../../../_generated/api_interfaces/api/jobCard.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-job-status',
    templateUrl: './job-status.component.html',
    styleUrls: ['./job-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class JobStatusComponent {
    @Input() public job: Partial<{ statusLabel: string; status: string | object; statusChange: string; referredToDipl: boolean }>;
}
